import { PromotionReactivatorForm } from '@/modules/automations/ui/forms/promotion-reactivator-form'
import { SettingsSkeleton } from '@/modules/automations/ui/skeleton'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider'

export const PromotionReactivatorView = () => {
  const { promotionReactivator, defaultPromotionFinishDays, isFetching } =
    useSettingsContext()

  if (isFetching) {
    return <SettingsSkeleton />
  }

  return (
    <PromotionReactivatorForm
      data={{ promotionReactivator, defaultPromotionFinishDays }}
    />
  )
}
